import {
  GET_LIST,
  GET_ONE,
  GET_MANY,
  GET_MANY_REFERENCE,
  CREATE,
  UPDATE,
  DELETE,
} from 'admin-on-rest'
import * as firebase from 'firebase'
import * as moment from 'moment'

import { getCurrentUserId } from '../helpers'

export const FUNCTION = 'FUNCTION'

export default () => {
  /**
   * @param {String} type One of the constants appearing at the top if this file, e.g. 'UPDATE'
   * @param {String} resource Name of the resource to fetch, e.g. 'posts'
   * @param {Object} params The REST request params, depending on the type
   * @returns {Object} { url, options } The HTTP request parameters
   */
  const manageRequest = (type, resource, params) => {
    // console.log('------------------')
    // console.log(type, resource, params)
    // console.log(params)
    // console.log(resource)

    if (resource === 'instructors-upcoming') {
      return getInstructorCourses(firebase, 'upcoming')
    }

    if (resource === 'instructors-in-progress') {
      return getInstructorCourses(firebase, 'in_progress')
    }

    if (resource === 'instructors-completed') {
      return getInstructorCourses(firebase, 'completed')
    }

    if (resource === 'courses-completed') {
      resource = 'courses'

      return firebase
        .database()
        .ref(`courseDetails/completed`)
        .once('value')
        .then((response) => {
          if (response.exists()) {
            let courseIds = Object.keys(response.val())

            return Promise.all(
              courseIds.map((id) =>
                firebase.database().ref(`courses/${id}`).once('value'),
              ),
            ).then((response) => ({
              data: response.map((x) => ({ ...x.val(), id: x.key })),
              total: courseIds.length,
            }))
          } else {
            return Promise.resolve({ data: [], total: 0 })
          }
        })
    }

    if (resource === 'cursuri-in-desfasurare') {
      return getStudentCourses(
        (course) => course.enrolled && course.status === 'in_progress',
      )
    }

    if (resource === 'cursuri-inscrise') {
      return getStudentCourses(
        (course) =>
          course.enrolled &&
          course.status !== 'completed' &&
          course.status !== 'in_progress',
      )
    }

    if (resource === 'credits') {
      // We actually only need the completed courses
      return getStudentCourses((course) => course.status === 'completed')
    }

    if (resource === 'cursuri-disponibile') {
      resource = 'courses'
      const page =
        params.pagination && params.pagination.page != null
          ? params.pagination.page
          : 1
      const perPage =
        params.pagination && params.pagination.perPage != null
          ? params.pagination.perPage
          : 10
      const field =
        params.sort && params.sort.field != null ? params.sort.field : 'name'
      const filter = params.filter
      // TOOD - figure out ordering, filter, include

      // console.log({ resource, filter })

      return firebase
        .database()
        .ref(resource)
        .orderByChild(field)
        .once('value')
        .then(function (response) {
          if (response.exists()) {
            let results = []

            // console.log(response.numChildren())
            const now = moment()

            response.forEach((courseSnapshot) => {
              let course = { ...courseSnapshot.val(), id: courseSnapshot.key }
              const startOfDate = moment(course.date)
              //ALlow enroll up to 1 day before
              const isInTheFuture = startOfDate.diff(now, 'minutes') >= 1

              if (
                isInTheFuture &&
                course.status !== 'completed' &&
                course.status !== 'in_progress'
              ) {
                results.push(course)
              }
            })

            let numChildren = results.length

            if (
              params.sort &&
              params.sort.order != null &&
              params.sort.order === 'DESC'
            ) {
              results.reverse()
            }

            results = results.slice(
              (page - 1) * perPage,
              (page - 1) * perPage + perPage,
            )

            return {
              data: results,
              total: numChildren,
            }
          }

          return Promise.resolve({ data: [], total: 0 })
        })
    }

    switch (type) {
      case GET_LIST: {
        // console.log(resource)
        // console.log(params)

        const page =
          params.pagination && params.pagination.page != null
            ? params.pagination.page
            : 1
        const perPage =
          params.pagination && params.pagination.perPage != null
            ? params.pagination.perPage
            : 10
        const field =
          params.sort && params.sort.field != null ? params.sort.field : 'name'
        const filter = params.filter

        // TOOD - figure out ordering, filter, include

        // console.log({ field, resource, filter })

        return firebase
          .database()
          .ref(resource)
          .orderByChild(field)
          .once('value')
          .then(function (response) {
            if (response.exists()) {
              let results = []

              // console.log(response.numChildren())

              response.forEach(function (childSnapshot) {
                let childObj = { ...childSnapshot.val(), id: childSnapshot.key }
                // if (Object.keys(filter).length !== 0) {
                //   Object.keys(filter).forEach(function (key) {
                    //  console.log('key' + key + ' ' + filter[key])
                //     if (childObj.hasOwnProperty(key)) {
                //       if (childObj[key] === filter[key]) {
                //         results.push(childObj)
                //       }
                //     }
                //   })
                // } else {
                results.push(childObj)
                // }
              })

              // console.log(results)

              let numChildren = results.length

              if (
                params.sort &&
                params.sort.order != null &&
                params.sort.order === 'DESC'
              ) {
                results.reverse()
              }

              if (filter && Object.keys(filter).length > 0) {
                results = results.filter((r) =>
                  Object.keys(filter).every(function (key) {
                    // console.log('key' + key + ' ' + filter[key])
                    if (r.hasOwnProperty(key)) {
                      if (r[key].includes(filter[key])) {
                        return true
                      }
                    }
                    return false
                  }),
                )
              }

              const total = results.length

              results = results.slice(
                (page - 1) * perPage,
                (page - 1) * perPage + perPage,
              )

              return {
                data: results,
                total: total,
              }
            }

            return Promise.resolve({ data: [], total: 0 })
          })
      }

      case GET_ONE: {
        return firebase
          .database()
          .ref(`${resource}/${params.id}`)
          .once('value')
          .then(function (response) {
            let resultObject = { ...response.val(), id: response.key }
            // console.log(resultObject)
            return { data: resultObject }
          })
      }
      case GET_MANY: {
        return Promise.all(
          params.ids
            .filter((id) => !id.includes('['))
            .map((id) => {
              return firebase.database().ref(`${resource}/${id}`).once('value')
            }),
        ).then(function (response) {
          // console.log('response for getmany')
          return {
            data: response.map((x) => {
              let result = x.val()
              return { ...result, id: x.key }
            }),
          }
        })
      }
      case GET_MANY_REFERENCE: {
        const page =
          params.pagination && params.pagination.page != null
            ? params.pagination.page
            : 1
        const perPage =
          params.pagination && params.pagination.perPage != null
            ? params.pagination.perPage
            : 10

        // const field = (params.sort && params.sort.field != null) ? params.sort.field : "createdAt";
        // const order = (params.sort && params.sort.order != null) ? params.sort.order : "ASC";
        //     url = `${firebaseConfig.URL}/classes/${resource}?${queryParameters(query)}`;
        // TODO - Fix this
        // console.log(params.id)
        return firebase
          .database()
          .ref(resource)
          .orderByChild(`${params.target}/${params.id}`)
          .equalTo(true)
          .once('value')
          .then(function (response) {
            // console.log(response.val())
            if (response.exists()) {
              let results = []

              // console.log(response.numChildren())

              response.forEach(function (childSnapshot) {
                let childObj = { ...childSnapshot.val(), id: childSnapshot.key }
                results.push(childObj)
              })

              let numChildren = results.length

              if (
                params.sort &&
                params.sort.order != null &&
                params.sort.order === 'DESC'
              ) {
                results.reverse()
              }

              results = results.slice(
                (page - 1) * perPage,
                (page - 1) * perPage + perPage,
              )

              return {
                data: results,
                total: numChildren,
              }
            }

            return {
              data: [],
              total: 0,
            }
          })
      }
      case UPDATE:
        // url = `${firebaseConfig.URL}/classes/${resource}/${params.id}`;
        // options.method = 'PUT';
        delete params.data.id
        // delete params.data.createdAt;
        // delete params.data.updatedAt;
        // options.body = JSON.stringify(params.data);
        const updateData = JSON.parse(JSON.stringify(params.data))
        // console.log('update shit', params.data.date)
        // console.log('update shit', JSON.stringify(params.data))
        // console.log('update shit', JSON.parse(params.data.date))
        return firebase
          .database()
          .ref(`${resource}/${params.id}`)
          .set(updateData)
          .then(function () {
            return { data: { ...updateData, id: params.id } }
          })
      case CREATE:
        var id = firebase.database().ref().child(resource).push().key

        // console.log('CREATE', params)

        if (resource === 'courses') {
          let createData = { ...params.data }
          // createData.days = {}
          // createData.days['day1'] = { date: params.data.date, ind: 1 }

          // if (params.data.day2) {
            console.log('Day2')
          //   createData.days['day2'] = { date: params.data.day2, ind: 2 }
          // }
          // if (params.data.day3) {
            console.log('Day3')
          //   createData.days['day3'] = { date: params.data.day3, ind: 3 }
          // }

          // delete createData.day1
          // delete createData.day2
          // delete createData.day3
          const instructorKeys = Object.keys(createData.instructors)

          // console.log('instructor keys', instructorKeys)

          const updates = {
            [`courses/${id}`]: {
              ...createData,
              status: 'upcoming',
            },
            [`courseDetails/upcoming/${id}`]: true,
          }

          instructorKeys.forEach((key) => {
            updates[`instructors/${key}/courses/${id}`] = true
          })

          return firebase
            .database()
            .ref()
            .update(updates)
            .then(() => {
              return { data: { ...createData, id: id } }
            })
        } else {
          return firebase
            .database()
            .ref(`${resource}/${id}`)
            .set(params.data)
            .then(function () {
              return { data: { ...params.data, id: id } }
            })
        }

      case DELETE:
        if (resource === 'courses') {
          // We won't be actually deleting the course, just move it to archivedCourses
          // console.log('previousData', params.previousData)
          // return firebase
          //   .database()
          //   .ref(`${resource}/${id}`)
          //   .set(params.data)
          //   .then(function() {
          //     return { data: { ...params.data, id: id } }
          //   })
        }
        break
      case FUNCTION:
        // url = `${firebaseConfig.URL}/functions/${resource}`;
        // options.method = 'POST';
        // options.body = JSON.stringify(params.data);
        break
      default:
        throw new Error(`Unsupported fetch action type ${type}`)
    }

    return Promise.resolve()
  }

  /**
   * @param {string} type Request type, e.g GET_LIST
   * @param {string} resource Resource name, e.g. "posts"
   * @param {Object} payload Request parameters. Depends on the request type
   * @returns {Promise} the Promise for a REST response
   */
  return (type, resource, params) => {
    // console.log(
    //   '>>>>REQUEST rest client => ',
    //   type,
    //   ' => ',
    //   resource,
    //   ' => ',
    //   params,
    // )
    return manageRequest(type, resource, params).then((data) => {
      // console.log(
      //   '<<<<<<RESULT rest client => ',
      //   type,
      //   ' => ',
      //   resource,
      //   ' => ',
      //   params,
      //   '\nRESULT: ',
      //   data,
      // )
      return data
    })
  }
}

const getInstructorCourses = (firebase, courseStatus) => {
  var user = firebase.auth().currentUser

  if (user) {
    const uid = user.uid
    const instructorCourses = firebase
      .database()
      .ref(`instructors/${uid}/courses`)
      .once('value')
      .then((response) => {
        if (response.exists()) {
          let courseIds = Object.keys(response.val())
          return courseIds
        }
        return []
      })

    const coursesWithStatus = firebase
      .database()
      .ref(`courseDetails/${courseStatus}`)
      .once('value')
      .then((response) => {
        if (response.exists()) {
          let courseIds = Object.keys(response.val())
          return courseIds
        }
        return []
      })

    return Promise.all([coursesWithStatus, instructorCourses]).then(function (
      response,
    ) {
      const withStatusCoursesIds = response[0]
      const instructorCoursesIds = response[1]
      const withStatusCoursesForCurrentInstructorIds =
        withStatusCoursesIds.filter(function (n) {
          return instructorCoursesIds.indexOf(n) !== -1
        })

      return Promise.all(
        withStatusCoursesForCurrentInstructorIds.map((id) => {
          return firebase.database().ref(`courses/${id}`).once('value')
        }),
      ).then(function (response) {
        // console.log('response for all')
        // console.log(
        //   response.map((x) => {
        //     // console.log(x.val())
        //     let result = x.val()
        //     return { ...result, id: x.key }
        //   }),
        // )
        return {
          data: response.map((x) => {
            // console.log(x.val())
            let result = x.val()
            return { ...result, id: x.key }
          }),
          total: withStatusCoursesForCurrentInstructorIds.length,
        }
      })
    })
  }
}

const getStudentCourses = (filterCourse) => {
  if (getCurrentUserId() !== '') {
    return firebase
      .database()
      .ref(`students/${getCurrentUserId()}/courses`)
      .once('value')
      .then((response) => {
        if (response.exists()) {
          let courseIds = []
          response.forEach((courseSnapshot) => {
            let course = { ...courseSnapshot.val(), id: courseSnapshot.key }
            if (filterCourse(course)) {
              courseIds.push(courseSnapshot.key)
            }
          })

          return Promise.all(
            courseIds.map((id) =>
              firebase.database().ref(`courses/${id}`).once('value'),
            ),
          ).then((response) => ({
            data: response.map((x) => ({ ...x.val(), id: x.key })),
            total: courseIds.length,
          }))
        }

        return Promise.resolve({ data: [], total: 0 })
      })
  }
  // No user is signed in.
  return Promise.resolve({ data: [], total: 0 })
}



// WEBPACK FOOTER //
// ./src/rest/restClient.js